import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Clock, User, Calendar, Tag } from "lucide-react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { mockData } from "../data/mock";
import BlogPost1 from "./BlogPost1";
import BlogPost2 from "./BlogPost2";
import BlogPost3 from "./BlogPost3";
import BlogPost4 from "./BlogPost4";
import BlogPost5 from "./BlogPost5";
import BlogPost6 from "./BlogPost6";
import BlogPost7 from "./BlogPost7";
import BlogPost8 from "./BlogPost8";
import BlogPost9 from "./BlogPost9";

const BlogPostPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();

  // Scroll to top when component mounts or slug changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const blogComponents = [BlogPost1, BlogPost2, BlogPost3, BlogPost4, BlogPost5, BlogPost6, BlogPost7, BlogPost8, BlogPost9];

  // Find post by slug from mock data
  const findPostBySlug = (slug) => {
    const allPosts = mockData.blogCategories.flatMap(category => 
      category.posts.map(post => ({ ...post, category }))
    );
    
    return allPosts.find(post => post.id === slug);
  };

  const post = findPostBySlug(slug);

  const handleBack = () => {
    navigate('/blog');
  };

  if (!post) {
    return (
      <div className="min-h-screen bg-white">
        {/* Navigation Bar */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-[#112b3c]/95 backdrop-blur-md border-b border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-20">
              <div className="flex items-center">
                <button onClick={() => navigate('/')} className="flex items-center">
                  <img 
                    src="/credentra-logo-new.png" 
                    alt="Credentra Logo" 
                    className="h-52 w-auto"
                  />
                </button>
              </div>
              <div className="nav-links">
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={() => navigate('/blog')}
                  className="text-white hover:text-credentra-bright-teal font-medium px-4 py-2 ml-4"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back to Blog
                </Button>
              </div>
            </div>
          </div>
        </nav>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
          <h1 className="text-4xl font-bold text-credentra-dark-teal mb-4">Post Not Found</h1>
          <p className="text-xl text-gray-600 mb-8">The blog post you're looking for doesn't exist or has been moved.</p>
          <Button onClick={() => navigate('/blog')} className="bg-credentra-dark-teal hover:bg-credentra-dark-teal/90">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Blog
          </Button>
        </div>
      </div>
    );
  }

  const BlogComponent = blogComponents[post.componentIndex];

  if (!BlogComponent) {
    return (
      <div className="min-h-screen bg-white">
        <nav className="fixed top-0 left-0 right-0 z-50 bg-[#112b3c]/95 backdrop-blur-md border-b border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-20">
              <div className="flex items-center">
                <button onClick={() => navigate('/')} className="flex items-center">
                  <img 
                    src="/credentra-logo-new.png" 
                    alt="Credentra Logo" 
                    className="h-52 w-auto"
                  />
                </button>
              </div>
              <div className="nav-links">
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={handleBack}
                  className="text-white hover:text-credentra-bright-teal font-medium px-4 py-2 ml-4"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back to Blog
                </Button>
              </div>
            </div>
          </div>
        </nav>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
          <h1 className="text-4xl font-bold text-credentra-dark-teal mb-4">Content Not Available</h1>
          <p className="text-xl text-gray-600 mb-8">This blog post content is not available at the moment.</p>
          <Button onClick={handleBack} className="bg-credentra-dark-teal hover:bg-credentra-dark-teal/90">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Blog
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#112b3c]/95 backdrop-blur-md border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <button onClick={() => navigate('/')} className="flex items-center">
                <img 
                  src="/credentra-logo-new.png" 
                  alt="Credentra Logo" 
                  className="h-52 w-auto"
                />
              </button>
            </div>
            <div className="nav-links">
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={handleBack}
                className="text-white hover:text-credentra-bright-teal font-medium px-4 py-2 ml-4"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Blog
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* Blog Post Content */}
      <BlogComponent onBack={handleBack} />
    </div>
  );
};

export default BlogPostPage;